import React from 'react';
import PropTypes from 'prop-types';
import Label from '@spothero/ui/label';
import Icon from 'common/icon/Icon';

const ImportantInformation = ({
    data: {
        details: {
            code,
            spot_type: spotType
        },
        shuttle: {
            duration,
            fast_frequency: shuttleMin,
            slow_frequency: shuttleMax,
            type: shuttleType
        }
    }
}) => {
    const displayDuration = (shuttleType !== 'taxi'
        && shuttleType !== 'curbside-valet'
        && shuttleType !== 'public-transit'
    );
    let rideType = 'Shuttle';
    let serviceLabel = 'Shuttle Every';
    let shuttleSpan = null;
    let shuttleIcon = 'shuttle';

    if (shuttleMin && shuttleMax) {
        shuttleSpan = `${shuttleMin} - ${shuttleMax}`;
    } else if (shuttleMin && !shuttleMax) {
        shuttleSpan = shuttleMin;
    } else if (!shuttleMin && shuttleMax) {
        shuttleSpan = shuttleMax;
    }

    let serviceDescription = `${shuttleSpan} Min`;

    if (shuttleType === 'taxi') {
        rideType = 'Taxi';
        shuttleIcon = 'car';
        serviceDescription = 'Taxi';
        serviceLabel = 'Taxi/Rideshare';
    } else if (shuttleType === 'curbside-valet') {
        rideType = 'Concierge';
        serviceLabel = 'Concierge Service';
        serviceDescription = 'Curbside Dropoff';
    } else if (shuttleType === 'on-demand') {
        serviceLabel = 'Shuttle';
        serviceDescription = 'On Demand';
        shuttleIcon = 'concierge';
    } else if (shuttleType === 'public-transit') {
        rideType = 'Public Transit';
        serviceLabel = 'Park and Ride';
        serviceDescription = 'Public Transit Accessible';
    }

    return (
        <div className="ImportantInformation">
            <div className="ImportantInformation-item">
                <Icon name="parking" />
                <div className="ImportantInformation-item-content">
                    <Label>Spot Type</Label>
                    <p>{spotType}</p>
                </div>
            </div>
            <div className="ImportantInformation-item">
                <Icon name={shuttleIcon} />
                <div className="ImportantInformation-item-content">
                    <Label>{serviceLabel}</Label>
                    <p>{serviceDescription}</p>
                </div>
            </div>
            {displayDuration &&
                <div className="ImportantInformation-item">
                    <Icon name="clock" />
                    <div className="ImportantInformation-item-content">
                        <Label>{rideType} To {code}</Label>
                        <p>{duration} Min</p>
                    </div>
                </div>
            }
        </div>
    );
};

ImportantInformation.propTypes = {
    data: PropTypes.object.isRequired
};

export default ImportantInformation;
